import { render, staticRenderFns } from "./TooltipTextLackOfRest.vue?vue&type=template&id=1231f61e"
import script from "./TooltipTextLackOfRest.vue?vue&type=script&lang=js"
export * from "./TooltipTextLackOfRest.vue?vue&type=script&lang=js"
import style0 from "./TooltipTextLackOfRest.vue?vue&type=style&index=0&id=1231f61e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports